import { useEffect, useRef, useState } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold"
  }
};

const FotografijaModal = ({
  handleConfirm,
  handleCancel,
  fotoLink,
  fotoFile
}) => {
  const [newFile, setNewFile] = useState(null);
  const [newFotoLink, setNewFotoLink] = useState(null); // delete detection

  const fileInputRef = useRef();

  const { dictionary } = useGlobalContext();

  useEffect(() => {
    setNewFile(fotoFile);
  }, [fotoFile]);

  useEffect(() => {
    setNewFotoLink(fotoLink);
  }, [fotoLink]);

  const handleUcitajFile = () => {
    fileInputRef.current.value = "";
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setNewFile(file);
  };

  const handleSacuvaj = () => {
    handleConfirm(newFile, newFotoLink);
  };

  const handleIzbrisi = () => {
    setNewFile(null);
    setNewFotoLink(null);
  };

  return (
    <div
      style={{
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          width: "60%",
          borderRadius: "10px",
          padding: "20px"
        }}
      >
        <div
          style={{
            marginBottom: "30px",
            marginTop: "30px",
            textAlign: "center",
            fontSize: "18px",
            backgroundColor: "white",
            // minHeight: "300px",
            maxHeight: "10%"
          }}
        >
          {!newFotoLink && !newFile && dictionary["nepostojiFotografija"]}
          {newFile ? (
            <img style={{ maxHeight: "400px"}} src={URL.createObjectURL(newFile)} />
          ) : newFotoLink ? (
            <img src={newFotoLink}  style={{ maxHeight: "400px"}} />
          ) : (
            ""
          )}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "white"
          }}
        >
          <div onClick={handleCancel}>
            <Button activation={true} style={styles.button}>
              {dictionary["odustani"]}
            </Button>
          </div>

          <div style={{ display: "flex", gap: "10px" }}>
            {newFotoLink && (
              <div onClick={handleIzbrisi}>
                <Button activation={true} style={styles.button}>
                  {dictionary["izbrisi"]}
                </Button>
              </div>
            )}
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            <div onClick={handleUcitajFile}>
              <Button activation={true} style={styles.button}>
                {newFotoLink
                  ? dictionary["izmeni"]
                  : dictionary["ucitajFotografiju"]}
              </Button>
            </div>
            <div onClick={handleSacuvaj}>
              <Button activation={true} style={styles.button}>
                {dictionary["sacuvaj"]}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FotografijaModal;
